import { Skeleton } from '../ui/skeleton';

export function ReceiptItemLoader() {
  return (
    <div className="rounded bg-white">
      {Array(5)
        .fill(null)
        .map((_, index) => (
          <div
            className="flex cursor-pointer items-center justify-between border-b border-gray-100 px-3 py-1.5"
            key={index}
          >
            <div className="flex w-full items-center space-x-3">
              <Skeleton className="bg-primary-platinum h-8 w-8 rounded" />
              <div className="flex h-11 flex-1 flex-col gap-1">
                <Skeleton className="bg-primary-platinum h-5 w-3/4" />
                <Skeleton className="h-5 w-3/4 bg-gray-100" />
              </div>
              <Skeleton className="bg-primary-platinum h-5 w-14 rounded-xl" />
            </div>
          </div>
        ))}
    </div>
  );
}
